import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12.9844" r="12" fill="#FF4C00" />
      <path
        d="M10.1654 16.1661L18.5229 7.80867C18.9134 7.41814 19.5465 7.41814 19.9371 7.80867L20.2929 8.16449C20.6834 8.55502 20.6834 9.18818 20.2929 9.57871L10.1654 19.7062L4.70711 14.2478C4.31658 13.8573 4.31658 13.2241 4.70711 12.8336L5.06293 12.4778C5.45345 12.0873 6.08662 12.0873 6.47714 12.4778L10.1654 16.1661Z"
        fill="white"
      />
    </svg>
  )
}
